import { useEffect, useState } from 'react';
import { Button } from '@/components/ui/button';
import { Label } from '@/components/ui/label';
import { Textarea } from '@/components/ui/textarea';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { DECLINE_EMAIL_SUBJECT, defaultDeclineBody } from '@/lib/leadDecline';

export function DeclineLeadModal({
  open,
  lead,
  onOpenChange,
  onSubmit,
  isSubmitting,
  error,
}) {
  const [message, setMessage] = useState('');

  useEffect(() => {
    if (open && lead) {
      setMessage(defaultDeclineBody(lead));
    }
  }, [open, lead]);

  const handleOpenChange = (next) => {
    if (!next) setMessage('');
    onOpenChange(next);
  };

  return (
    <Dialog open={open} onOpenChange={handleOpenChange}>
      <DialogContent
        className="max-w-lg"
        style={{ backgroundColor: '#0A192F', border: '1px solid rgba(212, 175, 55, 0.35)', color: '#F8F9FA' }}
      >
        <DialogHeader>
          <DialogTitle style={{ color: '#F8F9FA', fontFamily: 'Playfair Display, serif' }}>
            Declina Pratica
          </DialogTitle>
          <DialogDescription style={{ color: '#A0ABC0' }}>
            Verrà inviata un&apos;email di cortesia al danneggiato e la pratica verrà archiviata come declinata.
          </DialogDescription>
        </DialogHeader>
        <div className="space-y-4">
          <div>
            <p className="text-xs uppercase tracking-wide mb-1" style={{ color: '#D4AF37' }}>
              Destinatario
            </p>
            <p className="text-sm break-all" style={{ color: '#F8F9FA' }} data-testid="decline-recipient-email">
              {lead?.email || 'Email non disponibile'}
            </p>
            <p className="text-[11px] mt-2" style={{ color: '#A0ABC0' }}>
              Oggetto: {DECLINE_EMAIL_SUBJECT}
            </p>
          </div>
          <div className="space-y-1.5">
            <Label htmlFor="decline-message" style={{ color: '#E2E8F0' }}>
              Messaggio
            </Label>
            <Textarea
              id="decline-message"
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              rows={10}
              className="resize-y min-h-[180px]"
              style={{ backgroundColor: '#112240', color: '#F8F9FA', borderColor: 'rgba(255,255,255,0.12)' }}
              data-testid="decline-message"
            />
          </div>
          {error ? (
            <p className="text-sm" style={{ color: '#FCA5A5' }} role="alert">
              {error}
            </p>
          ) : null}
          <div className="flex justify-end gap-2">
            <Button type="button" variant="ghost" onClick={() => handleOpenChange(false)} style={{ color: '#A0ABC0' }}>
              Annulla
            </Button>
            <Button
              type="button"
              onClick={() => onSubmit({ custom_message: message.trim() })}
              disabled={isSubmitting || !lead?.email}
              style={{ backgroundColor: '#D4AF37', color: '#0A192F' }}
              data-testid="decline-confirm-btn"
            >
              {isSubmitting ? 'Invio...' : 'Invia ed Archivia'}
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
